import { MenuProps } from "antd";
import { SetOutline } from "antd-mobile-icons";

export const Rooter: MenuProps["items"] = [
  {
    key: "board",
    icon: <SetOutline />,
    label: "数据看板",
  },
  {
    key: "cnt",
    icon: <SetOutline />,
    label: "内容管理",
    children: [
      {
        key: "post-group",
        label: "帖子",
        type: "group",
        children: [
          {
            key: "post",
            icon: <SetOutline />,
            label: "帖子管理",
          },
        ],
      },
      {
        key: "video-group",
        label: "视频",
        type: "group",
        children: [
          {
            key: "video",
            icon: <SetOutline />,
            label: "视频管理",
          },
        ],
      },
      {
        key: "videoType-group",
        label: "视频分类",
        type: "group",
        children: [
          {
            key: "video-type",
            icon: <SetOutline />,
            label: "视频类型",
          },
          {
            key: "video-album",
            icon: <SetOutline />,
            label: "视频专辑",
          },
          {
            key: "video-tag",
            icon: <SetOutline />,
            label: "视频标签",
          },
          {
            key: "video-tag-type",
            icon: <SetOutline />,
            label: "视频标签类型",
          },
        ],
      },
      {
        key: "comment-group",
        label: "评论",
        type: "group",
        children: [
          {
            key: "comment",
            icon: <SetOutline />,
            label: "评论管理",
          },
        ],
      },
    ],
  },
  {
    key: "ope",
    icon: <SetOutline />,
    label: "运营管理",
    children: [
      {
        key: "anno",
        icon: <SetOutline />,
        label: "公告",
      },
      {
        key: "carousel",
        icon: <SetOutline />,
        label: "轮播图",
      },
      {
        key: "carousel-type",
        icon: <SetOutline />,
        label: "轮播图类型",
      },
      {
        key: "media",
        icon: <SetOutline />,
        label: "媒体",
      },
      {
        key: "webset",
        icon: <SetOutline />,
        label: "网站设置",
      },
    ],
  },
  {
    key: "usr",
    icon: <SetOutline />,
    label: "用户管理",
    children: [
      {
        key: "clock-group",
        label: "签到",
        type: "group",
        children: [
          {
            key: "clock",
            icon: <SetOutline />,
            label: "签到",
          },
          {
            key: "clock-list",
            icon: <SetOutline />,
            label: "签到列表",
          },
        ],
      },
      {
        key: "usr-group",
        label: "用户",
        type: "group",
        children: [
          {
            key: "feedback",
            icon: <SetOutline />,
            label: "用户反馈",
          },
          {
            key: "user-detail",
            icon: <SetOutline />,
            label: "用户详情",
          },
          {
            key: "user-group",
            icon: <SetOutline />,
            label: "用户组",
          },
          {
            key: "video-list",
            icon: <SetOutline />,
            label: "用户视频列表",
          },
        ],
      },
    ],
  },
  {
    key: "sys",
    icon: <SetOutline />,
    label: "权限管理",
    children: [
      {
        key: "menu",
        icon: <SetOutline />,
        label: "菜单",
      },
      {
        key: "role",
        icon: <SetOutline />,
        label: "角色",
      },
      {
        key: "user",
        icon: <SetOutline />,
        label: "用户",
      },
    ],
  },
];
